/* eslint-disable */

import axios from 'axios';

//axios.defaults.baseURL = 'https://y0gky23tog.execute-api.us-east-1.amazonaws.com/dev';
axios.defaults.baseURL = process.env.VUE_APP_TEAMIO_API_URL

export default {

    namespaced: true,
    state: {
        data: [],
    },
    mutations: {

    },
    actions: {

        async getMoolahConfig({commit, dispatch}, siteID) {
            try {
                let response = await axios.get('/get-moolah-config', { params: { siteID }, crossdomain: true });
                return response.data;
            } catch(err) {
                console.log('Error getting moolah config:', err);
                throw err;
            }
        },

        async saveMoolahConfig({commit, dispatch}, payload) {
            try {
                let response = await axios.post('/save-moolah-config', payload, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.log('Error saving moolah config:', err);
                throw err;
            }
        },

        async validateMoolahCredentials({commit, dispatch}, payload) {
            try {
                let response = await axios.post('/validate-moolah-credentials', payload, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.log('Error validating moolah credentials:', err);
                throw err;
            }
        },

        async getMoolahPaymentInfo({commit, dispatch}, paymentID) {
            try {
                let response = await axios.get(`/moolah-payment-info/${paymentID}`, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.log('Error getting moolah payment info:', err);
                throw err;
            }
        },

        async createMoolahPaymentRecord({commit, dispatch}, payload) {
            try {
                let response = await axios.post('/create-moolah-payment', payload, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.log('Error creating moolah payment record:', err);
                throw err;
            }
        },

        /**
         * Mark a pending payment as collected via a non-card method
         * (Cash / Check / 3rd-party financing). NO card is charged through
         * Moolah on this path — money already moved outside Teamio. The
         * backend flips Status='paid', stamps ProviderMetadata with the
         * method context, and triggers the OD write so OD records the
         * payment with the correct per-method Cat-10 PayType.
         *
         * Payload: { siteID, paymentID, method: 'cash'|'check'|'option',
         *            externalRef?, optionId?, intent? }
         */
        async markPaymentManuallyCollected({commit, dispatch}, payload) {
            try {
                let response = await axios.post('/mark-payment-manually-collected', payload, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.log('Error marking payment manually collected:', err);
                throw err;
            }
        },

        async processMoolahPayment({commit, dispatch}, payload) {
            try {
                let response = await axios.post('/process-moolah-payment', payload, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.log('Error processing moolah payment:', err);
                throw err;
            }
        },

        // ACTIVATED non-VT terminals for the site. Backend already filters per
        // the docs' display rule, so the response can be rendered directly.
        async getMoolahDevices({commit, dispatch}, siteID) {
            try {
                let response = await axios.get(`/get-moolah-devices?siteID=${encodeURIComponent(siteID)}`, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.log('Error fetching moolah devices:', err);
                throw err;
            }
        },

        // Sends a charge to a physical Poynt terminal. Synchronous on the
        // backend (waits for swipe), but per Moolah's own architecture
        // recommendation (2026-05-08): "Fire Off TO Unit → listen For
        // Webhook → Update UI". So we deliberately use a SHORT axios
        // timeout (8s) — long enough to capture the rare instant-decline,
        // short enough that the operator transitions to the polling state
        // quickly and gets Cancel + Check-status buttons.
        //
        // The Lambda continues running in the background regardless of
        // the axios cancel (we get an ECONNABORTED locally, the Lambda's
        // own work is unaffected). When the swipe completes, EITHER:
        //   - the Lambda eventually writes balance_payments.Status, OR
        //   - the webhook fires and our receiver writes it (now keyed by
        //     referenceId so it works even when the Lambda's POST hung)
        // The polling tick (1s) sees the flip and drives the UI.
        async chargeMoolahTerminal({commit, dispatch}, payload) {
            try {
                let response = await axios.post('/charge-moolah-terminal', payload, {
                    crossdomain: true,
                    timeout: 8000
                });
                return response.data;
            } catch(err) {
                console.log('Error charging moolah terminal:', err);
                throw err;
            }
        },

        // Marks an in-flight terminal-charge row as 'cancelled' so the
        // frontend can leave the spinning-wait UI cleanly. The physical
        // terminal is NOT actually aborted — Moolah doesn't expose a
        // server-side cancel for in-flight terminal payments. The backend
        // updatePaymentStatus is hardened to skip overwriting a
        // 'cancelled' row even if the swipe later resolves.
        async cancelMoolahTerminalPayment({commit, dispatch}, payload) {
            try {
                let response = await axios.post('/cancel-moolah-terminal-payment', payload, { crossdomain: true });
                return response.data;
            } catch(err) {
                console.log('Error cancelling moolah terminal payment:', err);
                throw err;
            }
        },

        // Recovery query — fetch the live transaction status from Moolah
        // when our balance_payments row is stuck on 'pending' (e.g. our
        // chargeMoolahTerminal Lambda's POST got lost en route). The
        // backend reconciles the DB row if the live status differs +
        // honours the non-terminal-only WHERE-clause so a frontend-
        // initiated 'cancelled' isn't silently overwritten.
        // Returns: { paymentID, storedStatus, liveStatus, dbUpdated, ... }
        async getMoolahTransactionStatus({commit, dispatch}, {siteID, paymentID}) {
            try {
                let response = await axios.get('/moolah-transaction-status', {
                    params: { siteID, paymentID },
                    crossdomain: true
                });
                return response.data;
            } catch(err) {
                console.log('Error fetching moolah transaction status:', err);
                throw err;
            }
        }
    }
}